import { render, staticRenderFns } from "./ShowSplitViewButton.vue?vue&type=template&id=3756f0c4&"
import script from "./ShowSplitViewButton.vue?vue&type=script&lang=js&"
export * from "./ShowSplitViewButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports